import jwt_decode from "jwt-decode";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { getUser } from "../pages/userSlice";


/** Hook de autenticación que protege rutas según el rol del usuario.
 * @param {Object} params - Parámetros de configuración.
 * @param {string} [params.redirectPath="/"] - Ruta de redirección si no hay sesión.
 * @param {string} params.requiredRole - Rol requerido para acceder.
 * @param {React.ReactNode} [params.children] - Componente hijo a renderizar.
 * @param {string} [params.path] - Ruta para validación de menú.
 * @returns {React.ReactElement} Elemento con la ruta protegida. */
const useAuth = ({ redirectPath = "/", requiredRole, children, path }) => {
  const accessToken = localStorage.getItem("accessToken");
  const infoToken = localStorage.getItem("infoToken");
  const userInfo = useSelector(getUser);

  const existAccessToken = !!accessToken;
  const existInfoToken = !!infoToken;
  let role = "";
  if (userInfo && existInfoToken) {
    const infoUser = jwt_decode(infoToken);
    role = infoUser["custom:Role"];
    if (path !== "home" && role === "user") {
      let menu = userInfo.lstMenuStandar;
      if (!menu.some((url) => url?.includes(path))) {
        return <Navigate to={"/user/home"} replace />;
      }
    }
  }
  if (existInfoToken) {
    const userInfo = jwt_decode(infoToken);
    role = userInfo["custom:Role"];
  }
  if (!existAccessToken || !existInfoToken) {
    return <Navigate to={redirectPath} replace />;
  }
  if (role === requiredRole) {
    return children ? children : <Outlet />;
  } else {
    if (role === "user") {
      return <Navigate to={"/user/home"} replace />;
    }

    if (role === "admin") {
      return <Navigate to={"/admin/home"} replace />;
    }
  }
};

export default useAuth;